import { Availability } from '@availability/const';
import { createSelector, MemoizedSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { getAvailabilityKey } from '../actions/availability.action';
import { AvailabilityState, StateWithAvailability } from '../availability-state';
import { getAvailabilityFeatureState } from './feature.selector';

interface Props {
  productCode: string;
  unitCode: string;
}

const getAvailabilityKeyByProps = (props: Props): string => {
  const { productCode, unitCode } = props;

  return getAvailabilityKey(productCode, unitCode);
};

export const getAvailabilityState: MemoizedSelector<
  StateWithAvailability,
  StateUtils.EntityLoaderState<Availability>
> = createSelector(getAvailabilityFeatureState, (state: AvailabilityState) => state.availability);

export const getAvailability = (
  props: Props,
): MemoizedSelector<StateWithAvailability, StateUtils.LoaderState<Availability>> =>
  createSelector(getAvailabilityState, (state: StateUtils.EntityLoaderState<Availability>) => {
    const availabilityKey = getAvailabilityKeyByProps(props);

    return StateUtils.entityLoaderStateSelector<Availability>(state, availabilityKey);
  });

export const getAvailabilityValue = (props: Props): MemoizedSelector<StateWithAvailability, Availability> =>
  createSelector(getAvailabilityState, (state: StateUtils.EntityLoaderState<Availability>) => {
    const availabilityKey = getAvailabilityKeyByProps(props);

    return StateUtils.entityValueSelector<Availability>(state, availabilityKey);
  });

export const getAvailabilityLoading = (props: Props): MemoizedSelector<StateWithAvailability, boolean> =>
  createSelector(getAvailabilityState, (state: StateUtils.EntityLoaderState<Availability>) => {
    const availabilityKey = getAvailabilityKeyByProps(props);

    return StateUtils.entityLoadingSelector<Availability>(state, availabilityKey);
  });

export const getAvailabilityError = (props: Props): MemoizedSelector<StateWithAvailability, boolean> =>
  createSelector(getAvailabilityState, (state: StateUtils.EntityLoaderState<Availability>) => {
    const availabilityKey = getAvailabilityKeyByProps(props);

    return StateUtils.entityErrorSelector<Availability>(state, availabilityKey);
  });

export const getAvailabilitySuccess = (props: Props): MemoizedSelector<StateWithAvailability, boolean> =>
  createSelector(getAvailabilityState, (state: StateUtils.EntityLoaderState<Availability>) => {
    const availabilityKey = getAvailabilityKeyByProps(props);

    return StateUtils.entitySuccessSelector<Availability>(state, availabilityKey);
  });
